import $console from '@zuto/utilities/src/$console'
import SubmissionRepository from '../repository/submission-repository'
import { Application } from '../Mappers/ApplicationFormMapper'

interface SubmissionServiceResult {
  submitApplication: (
    application: Application
  ) => Promise<{
    success?: boolean
    redirectUrl: string,
    authToken?: string
  }>
}

const SubmissionService = (config: Record<string, string>): SubmissionServiceResult => {
  const submissionRepository = SubmissionRepository(config)
  const { submittedPageURL } = config

  const determineRedirect = (
    redirect: string,
    authToken: string,
    links: {
      Href: string,
      Rel: string
    }[]
  ) => {
    if (redirect) {
      return redirect
    }
    if (!authToken) {
      return submittedPageURL
    }
    const accountArea = links.filter((l) => l.Rel === 'account-area')
    if (accountArea.length > 0) {
      return accountArea[0].Href
    }
    return submittedPageURL
  }

  const submitApplication = (
    application: Application
  ) => new Promise<{
    redirectUrl: string,
    authToken?: string
  }>((resolve, reject) => {
    submissionRepository.submit(application).then((response) => {
      const { Redirect, UserAuthToken, _links: links } = response
      const redirect = determineRedirect(Redirect, UserAuthToken, links)
      
      resolve({
        redirectUrl: redirect,
        authToken: UserAuthToken      
      })
    }).catch((error) => {
      $console.error('submitApplication error', error)
      reject(error)
    })
  })

  return {
    submitApplication
  }
}

export default SubmissionService
